import { render } from "./EditUsername.vue?vue&type=template&id=5534a9b2&scoped=true"
import script from "./EditUsername.vue?vue&type=script&lang=js"
export * from "./EditUsername.vue?vue&type=script&lang=js"

import "./EditUsername.vue?vue&type=style&index=0&id=5534a9b2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5534a9b2"]])

export default __exports__